import Button from '@material-ui/core/Button';
// import MUIDataTable, { TableHeadCell } from 'mui-datatables';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import history from '../../utilities/history';

import SubheadingBarVariantTwo from '../../components/SubheadingBar/VariantTwo';
import MainHeading from '../../components/UI/MainHeading/MainHeading';
import MainSection from '../../components/UI/MainSection/MainSection';
import MyTableLoader from '../../components/UI/MyTableLoader/MyTableLoader';
import SubHeading from '../../components/UI/SubHeading/SubHeading';
import SubSection from '../../components/UI/SubSection/SubSection';

import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import FilterListOutlined from '@material-ui/icons/FilterListOutlined';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import WarningIcon from '@material-ui/icons/Warning';

import {
  Checkbox,
  ClickAwayListener,
  createStyles,
  Fade,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Radio,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { IDataRootObject } from './types';

const styles = (theme: Theme) =>
  createStyles({
    tableHead: {
      height: '2rem'
    },
    filter: {
      height: '0.8rem',
      float: 'right'
    },
    sl: {
      width: '60px',
      padding: '0 10px'
    },
    error: {
      background: theme.tertiaryColors.red
    },
    warning: {
      background: theme.tertiaryColors.orange
    },
    successIcon: {
      color: '#a5ff4b',
      verticalAlign: 'middle',
      height: '2rem'
    },
    errorIcon: {
      color: '#ff6e6b',
      verticalAlign: 'middle',
      height: '2rem'
    },
    warningIcon: {
      color: '#f7ae64',
      verticalAlign: 'middle',
      height: '2rem'
    },
    iconText: {
      verticalAlign: 'middle'
    },
    viewIcon: {
      height: '1.2rem',
      verticalAlign: 'middle',
      marginRight: '0.2rem'
    },
    viewButton: {
      height: '1.8rem',
      padding: '4px 10px'
    }
  });

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.tertiaryColors.grey,
    color: theme.palette.common.white,
    textTransform: 'uppercase',
    height: '0.5rem',
    padding: '10px'
  },
  body: {
    fontSize: 14,
    padding: '10px'
  }
}))(TableCell);

const Capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const TableFilterHeader = ({
  label,
  type,
  search_key,
  search_values,
  classes,
  selected,
  setSelected
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <div>
      {label}
      <FilterListOutlined
        className={classes.filter}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpen(true);
        }}
      />
      <Popper
        open={open}
        transition
        anchorEl={anchorEl}
        className={classes.popperOffset}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={100}>
            <ClickAwayListener
              onClickAway={() => {
                setOpen(false);
                setAnchorEl(null);
              }}
            >
              <Paper style={{ overflowY: 'scroll', maxHeight: '40vh' }}>
                <MenuList>
                  {type === 'radio' && (
                    <MenuItem
                      style={{ textTransform: 'uppercase', paddingLeft: 0 }}
                      onClick={() => {
                        setSelected([]);
                      }}
                    >
                      <Radio
                        checked={selected.length === 0}
                        color="primary"
                        name={search_key}
                        classes={{
                          root: classes.checkboxRoot,
                          checked: classes.checked
                        }}
                      />
                      All
                    </MenuItem>
                  )}
                  {search_values.map((value) => {
                    return (
                      <MenuItem
                        key={value}
                        style={{ textTransform: 'uppercase', paddingLeft: 0 }}
                        onClick={() => {
                          if (type === 'checkbox') {
                            setSelected(
                              selected.indexOf(value) > -1
                                ? selected.filter((s) => s !== value)
                                : [...selected, value]
                            );
                          } else {
                            setSelected([value]);
                          }
                        }}
                      >
                        {type === 'checkbox' ? (
                          <Checkbox
                            checked={selected.indexOf(value) > -1}
                            color="primary"
                            name={search_key}
                            classes={{
                              root: classes.checkboxRoot,
                              checked: classes.checked
                            }}
                          />
                        ) : (
                          <Radio
                            checked={selected.indexOf(value) > -1}
                            color="primary"
                            name={search_key}
                            classes={{
                              root: classes.checkboxRoot,
                              checked: classes.checked
                            }}
                          />
                        )}
                        {value}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Paper>
            </ClickAwayListener>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

const TableFilterHeaderWithStyles = withStyles((theme) => ({
  filter: {
    height: '0.8rem',
    float: 'right',
    cursor: 'pointer'
  },
  popperOffset: {
    marginTop: '12px'
  }
}))(TableFilterHeader);

const SwitcherTable: React.FC<
  {
    loading: boolean;
    rows: IDataRootObject[];
    lastFetched: string;
  } & WithStyles
> = ({ loading, rows, lastFetched, classes }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filter, setFilter] = useState({
    customer_name: [],
    channel: [],
    switcher_name: [],
    active_source: [],
    output: []
  });

  useEffect(() => {
    setFilteredRows(
      rows.filter((row) => {
        if (Object.values(filter).flat().length === 0 && !search) {
          return true;
        }
        if (
          filter.switcher_name.length > 0 &&
          filter.switcher_name.indexOf(row.switcher_name) === -1
        ) {
          return false;
        }
        if (
          filter.active_source.length > 0 &&
          filter.active_source.indexOf(row.active_source.type) === -1
        ) {
          return false;
        }
        if (
          filter.output.length > 0 &&
          filter.output.indexOf(row.output) === -1
        ) {
          return false;
        }
        return true;
      })
    );
  }, [rows, setFilteredRows, search, filter]);

  // useEffect(() => {
  //   setAppliedFiltersKeys(
  //     Object.keys(filter).filter(k => filter[k].length > 0)
  //   );
  // }, [filter, setAppliedFiltersKeys]);

  return (
    <MainSection>
      <MainHeading
        mainHeading={'Switcher Monitor'}
        searchPlaceholder={'Search by Channel / Customer name'}
        onSearch={(e) => {
          setSearch(e.target.value);
        }}
        showButton={false}
      />
      <SubSection>
        <SubHeading>
          <SubheadingBarVariantTwo
            title="Switcher Overview"
            loading={loading}
            lastFetched={lastFetched}
          />
        </SubHeading>
        {loading ? (
          <MyTableLoader />
        ) : (
          <>
            {/* <pre>{JSON.stringify(filter, null, 2)}</pre> */}
            <Table>
              <TableHead>
                <TableRow className={classes.tableHead}>
                  <CustomTableCell className={classes.sl}>
                    S. No
                  </CustomTableCell>
                  <CustomTableCell>
                    <TableFilterHeaderWithStyles
                      label="Switcher Name"
                      type="checkbox"
                      search_key="switcher_name"
                      search_values={Array.from(
                        new Set(rows.map((r) => r.switcher_name))
                      ).sort((a, b) => a.localeCompare(b))}
                      selected={filter.switcher_name}
                      setSelected={(vals) =>
                        setFilter((fs) => ({ ...fs, switcher_name: vals }))
                      }
                    />
                  </CustomTableCell>
                  <CustomTableCell>Switcher Type</CustomTableCell>
                  <CustomTableCell>Switch Mode</CustomTableCell>
                  <CustomTableCell>
                    <TableFilterHeaderWithStyles
                      label="Active Source"
                      type="radio"
                      search_key="active_source"
                      search_values={Array.from(
                        new Set(rows.map((r) => r.active_source.type))
                      ).sort((a, b) => a.localeCompare(b))}
                      selected={filter.active_source}
                      setSelected={(vals) =>
                        setFilter((fs) => ({ ...fs, active_source: vals }))
                      }
                    />
                  </CustomTableCell>
                  <CustomTableCell>Backup Source(s)</CustomTableCell>
                  <CustomTableCell>Preferred Source</CustomTableCell>
                  <CustomTableCell>
                    <TableFilterHeaderWithStyles
                      label="Output Health"
                      type="radio"
                      search_key="output"
                      search_values={Array.from(
                        new Set(rows.map((r) => r.output))
                      ).sort((a, b) => a.localeCompare(b))}
                      selected={filter.output}
                      setSelected={(vals) =>
                        setFilter((fs) => ({ ...fs, output: vals }))
                      }
                    />
                  </CustomTableCell>
                  <CustomTableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows
                  .slice(page * pageSize, (page + 1) * pageSize)
                  .map((row) => (
                    <TableRow
                      className={
                        row.priority === 0
                          ? ''
                          : row.priority === 1
                          ? classes.warning
                          : classes.error
                      }
                      key={row.slno}
                    >
                      <CustomTableCell className={classes.sl}>
                        {row.slno}
                      </CustomTableCell>
                      <CustomTableCell>{row.switcher_name}</CustomTableCell>
                      <CustomTableCell>
                        {row.type.length > 0 ? Capitalize(row.type) : 'Unknown'}
                      </CustomTableCell>
                      <CustomTableCell>
                        {row.switch_mode === 'AS_MODE_AUTO'
                          ? 'Automatic'
                          : 'Manual'}
                      </CustomTableCell>
                      <CustomTableCell>
                        <>
                          {row.active_source.status === 'AS_OK' ? (
                            <CheckCircleOutline
                              className={classes.successIcon}
                            />
                          ) : row.active_source.status === 'AS_WARNING' ? (
                            <WarningIcon className={classes.warningIcon} />
                          ) : (
                            <ErrorOutline className={classes.errorIcon} />
                          )}{' '}
                          <span className={classes.iconText}>
                            {row.active_source.name}
                          </span>
                        </>
                      </CustomTableCell>
                      <CustomTableCell>
                        <>
                          {row.backup_source.status === 'AS_OK' ? (
                            <CheckCircleOutline
                              className={classes.successIcon}
                            />
                          ) : (
                            <ErrorOutline className={classes.errorIcon} />
                          )}{' '}
                          <span className={classes.iconText}>
                            {row.backup_source.name}
                          </span>
                        </>
                      </CustomTableCell>
                      <CustomTableCell>
                        {row.preferred_source.name}
                      </CustomTableCell>
                      <CustomTableCell>{row.output}</CustomTableCell>
                      <CustomTableCell>
                        <Button
                          variant="outlined"
                          className={classes.viewButton}
                          onClick={() => {
                            history.push(
                              `/switcher/${row.switcher_name + '_' + row.type}`
                            );
                          }}
                        >
                          <VisibilityOutlined className={classes.viewIcon} />{' '}
                          View
                        </Button>
                      </CustomTableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={rows.length}
              rowsPerPage={pageSize}
              page={page}
              onChangePage={(e, p) => setPage(p)}
              onChangeRowsPerPage={(e) =>
                setPageSize(parseInt(e.target.value, 10))
              }
            />
          </>
        )}
      </SubSection>
    </MainSection>
  );
};

export default withStyles(styles)(SwitcherTable);
